import { render } from "./Signer.vue?vue&type=template&id=2a50a7c6"
import script from "./Signer.vue?vue&type=script&lang=js"
export * from "./Signer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__